'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $p_Lapp_data_FormQuantity__klass__jl_Class($thiz) {
  if ((!$thiz.aBs)) {
    $thiz.aBr = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass($thiz.gy);
    $thiz.aBs = true;
  }
  return $thiz.aBr;
}
export { $p_Lapp_data_FormQuantity__klass__jl_Class as $p_Lapp_data_FormQuantity__klass__jl_Class };
/** @constructor */
function $c_Lapp_data_FormQuantity(quantity, eq) {
  this.gy = null;
  this.ahC = null;
  this.aBr = null;
  this.aBs = false;
  this.gy = quantity;
  this.ahC = eq;
}
export { $c_Lapp_data_FormQuantity as $c_Lapp_data_FormQuantity };
$p = $c_Lapp_data_FormQuantity.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_FormQuantity;
/** @constructor */
function $h_Lapp_data_FormQuantity() {
}
export { $h_Lapp_data_FormQuantity as $h_Lapp_data_FormQuantity };
$h_Lapp_data_FormQuantity.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "FormQuantity";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.gy;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "quantity";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f = (function(x) {
  return ($p_Lapp_data_FormQuantity__klass__jl_Class(this).ca.I(x) && (this.ahC.auj(this.gy, x) && this.ahC.aui(this.gy, x)));
});
function $isArrayOf_Lapp_data_FormQuantity(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ju)));
}
export { $isArrayOf_Lapp_data_FormQuantity as $isArrayOf_Lapp_data_FormQuantity };
var $d_Lapp_data_FormQuantity = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_FormQuantity, "app.data.FormQuantity", ({
  ju: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_FormQuantity as $d_Lapp_data_FormQuantity };
//# sourceMappingURL=app.data.-Form-Quantity.js.map
